import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ParagraphCont, Title, Text } from './IntroductionSection.styles';
import { parseIndividualReportIntroduction } from '../../../helpers/helpers';
import PageSection from '../components/PageSection/PageSection';

interface IIntroductionSection {
  introduction: string;
}

const IntroductionSection: FC<IIntroductionSection> = ({ introduction }) => {
  const { t } = useTranslation();

  const parsedIntroduction = parseIndividualReportIntroduction(introduction);

  return (
    <PageSection ariaLabel="introduction">
      <PageSection.Header>
        <PageSection.Header.Title tag="h3" title={t('results.report.introduction.title')} />
      </PageSection.Header>
      <PageSection.Content>
        {parsedIntroduction.map(({ title, text }, index) => (
          <ParagraphCont id="ParagraphCont" key={index}>
            {title && title !== 'Placeholder' ? <Title as="h4">{title}</Title> : null}
            <Text id="Text" as="p">
              {text}
            </Text>
          </ParagraphCont>
        ))}
      </PageSection.Content>
    </PageSection>
  );
};

export default IntroductionSection;
